import { useDeleteSizeGrouping } from "http-hooks/sizeGrouping/useSizeGrouping";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteSizeGrouping({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteSizeGrouping();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Size Group"
      description="Are you sure you want to delete this size group? This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
